"use strict";

exports.__esModule = true;
exports.default = void 0;

var _pallette = _interopRequireDefault(require("./pallette"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Styled-components theme for Reassure-UI help components
 */
const {
  transparent,
  white,
  black,
  midGreen
} = _pallette.default;
var _default = {
  colors: {
    tooltip: {
      text: black,
      background: 'rgba(255,255,255,0.9)',
      inverted: {
        text: white,
        background: 'rgba(0,0,0,0.9)'
      }
    },
    tooltipToggle: {
      text: white,
      background: transparent,
      border: midGreen
    }
  }
};
exports.default = _default;